import PropTypes from 'prop-types';
export var CRUMBS_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
  path: PropTypes.string.isRequired,
  label: PropTypes.node.isRequired
}));